import React from 'react';
import { Helmet } from 'react-helmet';

import SubmittableLogo from '../../images/logos/Logo-Trans-Square.png';
import AppleIcon from '../../images/favicon/apple-touch-icon.png';
import SmallIcon from '../../images/favicon/favicon-16x16.png';
import Icon from '../../images/favicon/icon.png';

export default React.memo(
	({
		pageTitle,
		description,
		metaKeywords,
		featuredImage,
		location,
		noIndex,
		updatedAt,
		schema,
	}) => {
		const site = `https://www.submittable.com`;
		const url = location ? `${site}${location.pathname}` : site;
		let title = pageTitle?.trim();
		// check to see if pageTitle is redundant before adding '| Submittable' at the end:
		if (pageTitle) {
			if (
				pageTitle.slice(pageTitle.length - 13, pageTitle.length) ===
				'| Submittable'
			) {
				title = pageTitle.slice(0, pageTitle.length - 13);
			}
		}

		title = pageTitle
			? `${title} | Submittable`
			: // default if no pageTitle passed:
				`Submittable | Submission Management Software`;
		let image = featuredImage || `${site}${SubmittableLogo}`;
		const metaDescription =
			description ||
			`Submittable is the industry-leading submission management software. 
    Thousands of organizations worldwide use it to collect and review any type of content in one easy-to-use platform.`;

		// contentful serves images without https in front if it form some reason:
		if (image.slice(0, 2) === '//') image = 'https:' + image;

		//og image doesn't support .svg:
		if (image.slice(image.length - 3, image.length) === 'svg')
			image = `${site}${SubmittableLogo}`;

		return [
			<Helmet key="helmet">
				{/* lang attribute: */}
				<html lang="en" />
				{/* Demandbase script: */}
				{/* <script async id="demandbase-tracking" src="https://tag.demandbase.com/e8e80d2aafe3c078.min.js" type="text/javascript" /> */}
				{/* if noIndex is passed, don't index the page: */}
				{noIndex ? <meta name="robots" content="noindex" /> : null}
				{/* General tags */}
				<title>{title}</title>
				<meta charSet="utf-8" />
				<meta name="description" content={metaDescription} />
				<meta name="image" content={image} />
				{/* <link rel="canonical" href={url} /> */}
				<meta name="title" content={title} />
				{metaKeywords && (
					<meta name="keywords" content={metaKeywords.toString()} />
				)}
				{/* favicon links for google */}
				<link rel="apple-touch-icon" sizes="180x180" href={AppleIcon} />
				<link rel="icon" type="image/png" sizes="144x144" href={Icon} />
				<link rel="icon" type="image/png" sizes="16x16" href={SmallIcon} />
				{/* GSC Ownership Verification */}
				<meta
					name="google-site-verification"
					content="iSIZVUnH4CGyKIGyI5INSkA4ROgzMYxMpV3JJsslYoo"
				/>
				{/* Open Graph / Facebook */}
				<meta property="og:url" content={url} />
				<meta property="og:title" content={title} />
				{/* {image.slice(0, 5) === "https" ? <meta property="og:image:secure_url" content={image} /> : null} */}
				<meta property="og:image" content={image} />
				<meta property="og:description" content={metaDescription} />
				<meta property="og:image:width" content="1200" />
				<meta property="og:image:height" content="630" />
				<meta property="og:type" content="website" />
				<meta property="og:site_name" content="Submittable" />
				{updatedAt ? (
					<meta property="og:updated_time" content={updatedAt} />
				) : null}
				{/* Twitter */}
				<meta name="twitter:card" content="summary" />
				<meta name="twitter:site" content="@submittable" />
				<meta name="twitter:creator" content="@submittable" />
				<meta name="twitter:title" content={title} />
				<meta name="twitter:description" content={metaDescription} />
				<meta name="twitter:image" content={image} />
				<meta property="twitter:url" content={url} />
				<meta property="twitter:description" content={metaDescription} />
				<meta
					name="twitter:image:alt"
					content="Submittable - Submission Management Software"
				/>
				{/* Schema.org */}
				{schema && (
					<script type="application/ld+json">
						{JSON.stringify({
							'@context': 'https://schema.org',
							'@type': 'Organization',
							name: 'Submittable',
							url: url,
							logo: 'https://www.submittable.com/images/logo/submittable-logo-b.png',
							sameAs: [
								'https://blog.submittable.com/',
								'https://www.linkedin.com/company/submittable/',
								'https://www.instagram.com/submittable/',
								'https://www.youtube.com/channel/UCSZnPvsIW2heYmWezip3Q-g',
								'https://www.facebook.com/submittable/',
								'https://twitter.com/submittable/',
								'https://www.wehero.co',
								'https://www.wizehive.com',
								'https://hello.brightfunds.org',
							],
							address: {
								'@type': 'PostalAddress',
								streetAddress: '101 E Front Street, Ste 500',
								addressLocality: 'Missoula',
								addressRegion: 'MT',
								postalCode: '59802',
								addressCountry: 'US',
							},
						})}
					</script>
				)}
				<meta
					name="facebook-domain-verification"
					content="ogs7o04prba6kdklyorwpjzlttq1ro"
				/>{' '}
			</Helmet>,
		];
	}
);
